import { Col, ColProps } from 'antd';

export const AntCol = Col;

export type AntColProps = ColProps;
